import {
  hasRichTextAdvanced,
  IAdvancedRichText,
  RichTextAdvancedRender,
} from '@framework/engine';
import styled from 'styled-components';

const CandidateWidgetContainerWrapper = styled.div`
  width: 100%;
  padding: 24px;
  padding-bottom: 8px;
  border: 4px solid ${props => props.theme.colorSplit};
  border-radius: 4px;
  margin-bottom: 24px;
`;
const CandidateWidgetContainerTitle = styled.div`
  padding-bottom: 8px;
  font-size: 18px;
`;

export interface ICandidateWidgetContainerProps {
  children?: React.ReactNode;
  panelTitle?: IAdvancedRichText | undefined;
  showPanel?: boolean;
}

/**
 * Pannello contenitore per i widget seleziona candidato.
 *
 * Visualizza i `children` all'interno di una cornice stilizzata, con un titolo opzionale.
 *
 * Se `showPanel = false`, il componente renderizza solo i `children`.
 *
 */
export function CandidateWidgetContainer(
  props: ICandidateWidgetContainerProps,
) {
  const { children, panelTitle, showPanel } = props;
  if (showPanel === false) {
    return <>{children}</>;
  }

  const hasTitle = hasRichTextAdvanced(panelTitle);

  return (
    <CandidateWidgetContainerWrapper style={{ paddingTop: hasTitle ? 12 : 24 }}>
      {hasTitle && (
        <CandidateWidgetContainerTitle>
          <RichTextAdvancedRender inline text={panelTitle} />
        </CandidateWidgetContainerTitle>
      )}
      {children}
    </CandidateWidgetContainerWrapper>
  );
}
